import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { action, computed, observable, makeAutoObservable } from 'mobx';
import { useAsObservableSource } from 'mobx-react-lite';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { Trap } from 'src/components/Trap/Trap';
import Selection from 'src/components/Selection/Selection';
import EMPTY_HR_SILK from 'src/components/CustomersBar/EventsTab/RacingTab/assets/empty-hr-silk.png';

interface PropsTypes {
    userId: number;
    sport: string;
    selection: SelectionModel;
}

class State {
    @observable selectedEventId: number | null = null;

    public constructor(private readonly props: PropsTypes) {
        makeAutoObservable(this);
    }

    @action onSelectEvent = (selectedEventId: number): void => {
        if (this.selectedEventId === selectedEventId) {
            this.selectedEventId = null;
        } else {
            this.selectedEventId = selectedEventId;
        }
    };

    @action onCloseEvent = (): void => {
        this.selectedEventId = null;
    };

    @computed get number(): string | null {
        return this.props.selection.metaDataNumber ?? null;
    }

    @computed get silkUrl(): string | null {
        const silkUrl = this.props.selection.metaDataSilkUrl ?? null;
        if (silkUrl !== null) {
            return silkUrl.startsWith('/') ? silkUrl : null;
        }

        return null;
    }
}

export const AntePostRaceSummarySelection = observer('AntePostRaceSummarySelection', (propsIn: PropsTypes) => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new State(props));
    const { number } = state;
    const { sport, selection, userId } = props;

    return (
        <li key={selection.id}>
            <div className='race-summary__metadata'>
                {sport === 'horseracing' ? (
                    <>
                        {number !== null ? <span className='race-summary__number'>{number}</span> : null}
                        <img
                            className='race-summary__silk'
                            // TODO: Uncomment after bug fix with empty Silks on HR
                            // src={silkUrl !== null ? silkUrl : EMPTY_HR_SILK}
                            src={EMPTY_HR_SILK}
                            alt=''
                        />
                    </>
                ) : null}
                {sport === 'greyhoundracing' && number !== null ? (
                    <Trap
                        className='race-summary__trap'
                        number={parseInt(number, 10)}
                    />
                ) : null}
                {selection.name}
            </div>
            <Selection
                userId={userId}
                marketId={selection.marketId}
                selectionId={selection.id}
            >
                {selection.price?.f ?? ''}
            </Selection>
        </li>
    );
});
